/* Auto-generated from inline schema 2025-08-29T08:39:05.702Z */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: ['yes_no'],
    },
  },
  required: ['value'],
}

export const answerSchema = valueSchema
